// 임플란트 회사·시스템 전체 목록 — 외주 커스텀 [고치기]의 「전체 목록에서 고르기」(대표 11-01)
//   출처: research_notes/스캔바디_라이브러리_대응표 (GeoMedi 카탈로그 2026 · GT-Medical · Tru · DESS). 새 자료가 오면 여기에 더한다.
//   DEFAULT = 치과 의뢰서 기본 임플란트 칩(CreateOrder · functions/lib/clinic-implant-options.js DEFAULT_IMPLANTS 와 같게)
export const DEFAULT_IMPLANTS = ['Osstem TS Mini', 'Osstem TS Regular', 'Osstem TS Wide', 'Osstem KS'];
export const IMPLANT_CATALOG = [
    { brand: "Anthogyr", names: ["Anthogyr Axiom"] },
    { brand: "Astra Tech", names: ["Astra Tech OsseoSpeed EV", "Astra Tech OsseoSpeed TX"] },
    { brand: "B&B Dental", names: ["B&B Dental Dura-Vit"] },
    { brand: "BEGO", names: ["BEGO", "BEGO Semados Internal"] },
    { brand: "Bicon", names: ["Bicon Implant"] },
    { brand: "BioHorizons", names: ["BioHorizons Laser-Lok 3.0", "BioHorizons Tapered Internal"] },
    { brand: "Biomet 3i", names: ["Biomet 3i Certain", "Biomet 3i Osseotite"] },
    { brand: "Biotech", names: ["Biotech Kontact"] },
    { brand: "Bredent Medical", names: ["Bredent Medical Sky"] },
    { brand: "BTI", names: ["BTI External", "BTI Internal"] },
    { brand: "Camlog", names: ["Camlog", "Camlog Conelog"] },
    { brand: "Champions", names: ["Champions (R)evolution"] },
    { brand: "Dentis", names: ["Dentis S-Clean / One Q", "Dentis e-Clean", "Dentis i-Clean"] },
    { brand: "Dentium", names: ["Dentium NR-Line", "Dentium Screw Abutment", "Dentium SuperLine / Implantium"] },
    { brand: "Dentsply", names: ["Dentsply Ankylos", "Dentsply Ankylos Balance Base Abutment", "Dentsply XiVE / Frialit2"] },
    { brand: "DIO", names: ["DIO SM", "DIO UF / UFII"] },
    { brand: "GC", names: ["GC Aadva Implant"] },
    { brand: "Implant Direct", names: ["Implant Direct Legacy 3.0"] },
    { brand: "Keystone", names: ["Keystone Prima / Genesis", "Keystone PrimaConnex / Max-TL"] },
    { brand: "Klockner", names: ["Klockner KL / KL 0.7", "Klockner Vega"] },
    { brand: "Kyocera", names: ["Kyocera Finesia", "Kyocera POI"] },
    { brand: "Medentika", names: ["Medentika IPS"] },
    { brand: "Medentis Medical", names: ["Medentis Medical ICX"] },
    { brand: "MegaGen", names: ["MegaGen AnyOne", "MegaGen AnyRidge", "MegaGen EZ-plus", "MegaGen ExFeel (Internal)", "MegaGen Mini"] },
    { brand: "MIS", names: ["MIS C1", "MIS Seven"] },
    { brand: "MYTIS", names: ["MYTIS Arrow Implant"] },
    { brand: "NeoBiotech", names: ["NeoBiotech IS"] },
    { brand: "Neodent", names: ["Neodent CM", "Neodent GM"] },
    { brand: "Neoss", names: ["Neoss ProActive"] },
    { brand: "Nobel Biocare", names: ["Nobel Biocare Active", "Nobel Biocare Branemark", "Nobel Biocare Multi-Unit", "Nobel Biocare Replace"] },
    { brand: "Osstem", names: ["Osstem SS", "Osstem TS", "Osstem US"] },
    { brand: "Phibo", names: ["Phibo Aurea Evo"] },
    { brand: "SIC", names: ["SIC ACE / MAX"] },
    { brand: "Straumann", names: ["Straumann BLX", "Straumann Bone Level", "Straumann Screw-retained Abutment", "Straumann Tissue Level", "Straumann Tissue Level RN synOcta"] },
    { brand: "Sweden & Martina", names: ["Sweden & Martina Outlink2", "Sweden & Martina Premium"] },
    { brand: "Tekka", names: ["Tekka In-Kone"] },
    { brand: "Thommen", names: ["Thommen SPI"] },
    { brand: "Warantec", names: ["Warantec IU", "Warantec Oneplant"] },
    { brand: "Zimmer", names: ["Zimmer Eztetic", "Zimmer Spline", "Zimmer Tapered Abutment", "Zimmer Tapered Screw-Vent"] },
];
